import React from 'react'
import PropTypes from 'prop-types'

import { ModalWrapper } from 'components'
import { MaterialIcon } from '@dsny/dsny-component-library'

export class CustomInputSelect extends React.PureComponent {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    selected: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired
  }
  static defaultProps = {
    options: []
  }
  state = {
    expanded: false
  }
  handleToggle = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }
  handleClickOutside = () => {
    this.setState({ expanded: false })
  }
  handleClick = (val) => {
    const { handleChange } = this.props
    this.setState({ expanded: false })
    handleChange(val)
  }
  getSelectedName = () => {
    const { options, selected } = this.props
    for (let i = 0; i < options.length; i++) {
      if (options[i].value === selected) {
        return options[i].name
      }
    }
    return selected
  }
  render() {
    const { expanded } = this.state
    const { options, selected } = this.props
    const optionItems = options.map(
      (i, index) =>
        selected !== i.value && (
          <button
            key={`${i.name} ${index + 1}`}
            type="button"
            className="focus:outline-none transition hover:bg-gray-800"
            onClick={() => this.handleClick(i.value)}>
            <p className="px-4 py-3 text-left font-header text-sm">{i.name}</p>
          </button>
        )
    )
    return (
      <ModalWrapper onClickOutside={this.handleClickOutside}>
        <div className={` relative ${expanded ? 'mb-px' : ''}`}>
          <div
            className={`${
              expanded
                ? 'rounded-t border-t border-r border-l'
                : 'rounded border'
            } border-gray-550 bg-gray-860 shadow-md text-gray-225`}>
            <button
              type="button"
              className="w-full flex items-stretch focus:outline-none"
              onClick={this.handleToggle}>
              <div className="px-4 py-3 flex-1 text-left font-header text-sm truncate">
                {this.getSelectedName()}
              </div>
              <div className="p-2 flex items-center justify-center">
                <MaterialIcon
                  name={expanded ? 'KeyboardArrowUp' : 'KeyboardArrowDown'}
                  color="#EBEBEB"
                  style={{ fontSize: 24 }} />
              </div>
            </button>
          </div>
          <div
            className={`w-full flex flex-col max-h-64 z-10 absolute bg-gray-860 text-gray-225 border-l border-r border-b border-gray-550 rounded-b 
                                                            ${
                                                              expanded
                                                                ? 'visible opacity-100'
                                                                : 'invisible opacity-0'
                                                            }`}>
            {optionItems}
          </div>
        </div>
      </ModalWrapper>
    )
  }
}
